const map = {
	"./Allot.svg": 3145,
	"./AllotBlue.svg": 4189,
	"./ArrowLineDown.svg": 9916,
	"./BgVendor.svg": 4296,
	"./Bill.svg": 2032,
	"./BillBlue.svg": 9180,
	"./CAR.svg": 6999,
	"./Calendar.svg": 4321,
	"./Calender.svg": 8533,
	"./CallLogo.svg": 9342,
	"./CancelDuty.svg": 505,
	"./CarProfile.svg": 9106,
	"./Charger.svg": 1343,
	"./Clock.svg": 4195,
	"./Confirm.svg": 8601,
	"./Dashboard.svg": 6317,
	"./DashboardBlue.svg": 1833,
	"./DownloadBlue.svg": 7639,
	"./Driver.svg": 3065,
	"./DriverBlue.svg": 6221,
	"./DutyType.svg": 7759,
	"./EditIcon.svg": 200,
	"./EditIconGrey.svg": 5873,
	"./FilterIcon.svg": 598,
	"./Logo.svg": 3130,
	"./Logout.svg": 9501,
	"./LogoutBlue.svg": 4409,
	"./MailLogo.svg": 5599,
	"./NewsPaper.svg": 5652,
	"./Notification.svg": 2830,
	"./NotificationBlue.svg": 4334,
	"./Office.svg": 6671,
	"./OfficeBlue.svg": 5351,
	"./OfficeGrey.svg": 2738,
	"./OfficeLogo.svg": 8537,
	"./Operation.svg": 9670,
	"./OperationBlue.svg": 5494,
	"./Preview.svg": 8433,
	"./ProfileVendor.svg": 3056,
	"./QuoteImg.svg": 5078,
	"./RateCard.svg": 2103,
	"./RateCardBlue.svg": 6623,
	"./RatingStar.svg": 4116,
	"./Reservation.svg": 4719,
	"./ReservationBlue.svg": 7495,
	"./SignOutLogo.svg": 7153,
	"./Snack.svg": 267,
	"./Star.svg": 1895,
	"./SubVendorLogo.svg": 9152,
	"./Taxi.png": 8127,
	"./UploadIcon.svg": 3003,
	"./UserLogo.svg": 8195,
	"./Vehicle.svg": 3817,
	"./VehicleBlue.svg": 2509,
	"./Vendor.svg": 5597,
	"./VendorBlue.svg": 3401,
	"./WaterBottle.svg": 6092,
	"./Wifi.svg": 5932,
	"./applogo.png": 911,
	"./block.svg": 8058,
	"./blueCar.svg": 6567,
	"./blueLogo.svg": 8186,
	"./bookedTrip.svg": 3582,
	"./camera.svg": 8286,
	"./cancelledTrip.svg": 4049,
	"./car-engine.svg": 4014,
	"./car-parts.svg": 6526,
	"./carWheel.svg": 3044,
	"./checklist.svg": 9217,
	"./clapping.svg": 7697,
	"./cloudArrowUp.svg": 1422,
	"./coin.svg": 5792,
	"./companyLogo.svg": 6325,
	"./completedTrip.svg": 6391,
	"./cross.svg": 8045,
	"./deActivate.svg": 3237,
	"./delete.svg": 154,
	"./dlImg.svg": 1832,
	"./doc.svg": 5227,
	"./download.png": 5651,
	"./drop.svg": 208,
	"./favicon.ico": 804,
	"./filter.svg": 4969,
	"./filterBlue.svg": 3085,
	"./fire-extinguisher.svg": 6629,
	"./first-aid-kit.svg": 4089,
	"./gauge.svg": 2924,
	"./labelIcon.svg": 2076,
	"./locationLogo.svg": 767,
	"./lockicon.svg": 2081,
	"./login_bg.svg": 972,
	"./login_hand.png": 6434,
	"./mapImage.svg": 3606,
	"./mechanical.svg": 8594,
	"./meter.svg": 8106,
	"./mobile_bg.svg": 8197,
	"./moreDetailsLocation.svg": 9539,
	"./moreEditIcon.svg": 7683,
	"./notificationIcon.svg": 3773,
	"./onGoing.svg": 6602,
	"./otp_bg.svg": 1348,
	"./pageNotFound.svg": 3059,
	"./pdf.svg": 2443,
	"./pdfImg.svg": 5416,
	"./performance.svg": 2763,
	"./pickUp.svg": 6315,
	"./profileImg.svg": 1643,
	"./searchIcon.svg": 8592,
	"./smLocation.svg": 9550,
	"./smLocationIcon.svg": 5901,
	"./smStar.svg": 1623,
	"./splash_ic.png": 6331,
	"./tick.svg": 9104,
	"./wallet.svg": 5544,
	"./whiteCar.svg": 2436
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;